import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Col, Row, Divider } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as UsuarioCrud from 'services/usuario.service'

import * as FormGroups from './formGroups'

const validationSchema = Yup.object().shape({
  nombres: Yup.string().required(),
  apellidos: Yup.string().required()
})

const NuevoMainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const submitHandler = React.useCallback(
    (data, { setSubmitting }) => {
      UsuarioCrud.self
        .actualizarInfoPersonal(data)
        .then(() => {
          __zariContext.snack('success', 'Se ha actualizado la información personal.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  const formInitialValues = React.useMemo(() => {
    return {
      apellidos: editarData.apellidos || '',
      nombres: editarData.nombres || ''
    }
  }, [editarData])

  return (
    <Row>
      <Col md={12}>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={validationSchema}>
          {({ errors, handleSubmit, isSubmitting, touched }) => (
            <Form>
              <Divider title='Datos Básicos' />
              <Row>
                <Col md={3}>
                  <FormGroups.NombresFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.nombres}
                    iTouched={touched.nombres}
                  />
                </Col>
                <Col md={3}>
                  <FormGroups.ApellidosFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.apellidos}
                    iTouched={touched.apellidos}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className='text-right'>
                  <Button tiny outline onClick={handleSubmit} disabled={isSubmitting}>
                    Guardar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  )
}

export default NuevoMainForm
